import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import getCsrfTokenFromCookie from "@/util/csrf-token";
import handleTeacherError from "@/util/handle_teacher_error";
import apiRequest from '@/util/api-request';

export const useNextGradeStore = defineStore('nextGradeStore', {
  // actions
  actions: {
    async fetchAcademicSessions() {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/next_grade/target_academic_sessions/",
          headers: {
            "Content-Type": "application/json",
          },
        };
        const result = await apiRequest(config);
        return result.data
      }
      catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchStudentsRegistrationStatus(params) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          url: "/teacher/api/next_grade/students_registration_status/",
          headers: {
            "Content-Type": "application/json",
          },
          params: params
        };
        const registrationStatus = await apiRequest(config);
        return registrationStatus.data
      } catch (e) {
        handleTeacherError(e)
      }
    },
    async fetchDownloadStudentsRoster(params) {
      try {
        const config: AxiosRequestConfig = {
          method: "get",
          responseType: "blob",
          url: "/teacher/api/next_grade/download/",
          headers: {
            "Content-Type": "application/json",
          },
          params: params
        };
        const result = await apiRequest(config);
        return result
      } catch (e) {
        // ↓明示的に Json Response する status コードをここに追加する
        if ([400].includes(e.response.status)) {
          e = await new Promise((resolve) => {
            const fileReader = new FileReader();
            fileReader.onload = () => {
              if (typeof fileReader.result === "string") {
                e.response.data = JSON.parse(fileReader.result);
              }
              resolve(e);
            };
            fileReader.readAsText(e.response.data);
          });
        }
        handleTeacherError(e)
      }
    },
    async fetchNextGradeImport(payload) {
      try {
        const config: AxiosRequestConfig = {
          method: "post",
          url: "/teacher/api/next_grade/import/",
          headers: {
            "Content-Type": "multipart/form-data",
            "X-CSRFToken": getCsrfTokenFromCookie(document.cookie)
          },
          data: payload
        };
        const importResult = await apiRequest(config);
        return importResult.data
      } catch (e) {
        handleTeacherError(e)
      }
    }
  }
})